<template>
  <div class="page-class page-center">
    <div class="page-staff-form">
      <h1 class="page-title text-center">{{ title }}</h1>
      <promo-code-form-box
        list-url="/promo-code"
        :id="id"
        promoCode-type="promoCode"
        :form-type="formType"
        @add="onAdd"
        @edit="onEdit"
      >
      </promo-code-form-box>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import router from '@/router';
import PromoCodeFormBox from '../../components/PromoCodeFormBox.vue';

export default {
  name: 'PromoCodeForm',
  components: {
    PromoCodeFormBox
  },
  async mounted() {
    if (this.$route.name === 'promo-code-new') {
      this.formType = 'new';
      this.id = null;
    } else {
      this.formType = 'update';
      this.id = this.$route.params.id;

      await this.getOne({
        type: 'promoCode',
        id: this.id,
        router
      });
    }
  },
  data() {
    return {
      formType: '',
      id: null
    };
  },
  computed: {
    title() {
      return this.formType === 'new' ? 'Add New promoCode' : 'Update promoCode';
    },
    ...mapState('promoCode', ['loading'])
  },
  methods: {
    ...mapActions('promoCode', ['getOne', 'postOne', 'patchOne']),
    onAdd({ promoCode }) {
      this.postOne({
        promoCode,
        router,
        redirectUrl: '/promo-code'
      });
    },
    onEdit({ promoCode }) {
      this.patchOne({
        type: 'promoCode',
        id: this.id,
        promoCode,
        router,
        redirectUrl: '/promo-code'
      });
    }
  }
};
</script>
